<template>
    <validation-observer v-slot="{valid}">
        <b-modal body-class="position-static" content-class="w-auto" ref="modal" @hidden="resetForm" centered :id="id">
            <template v-slot:modal-title>Вход</template>
            <b-overlay :show="authLoading" rounded spinner-variant="primary" no-wrap />
            <login-form
                v-model="form"
                @change-captcha="changeCaptchaToken"
                ref="form"
                :show-captcha="showCaptcha"
                :captchaSiteKey="captchaSiteKey"
            />
            <template v-slot:modal-footer>
                <div class="w-100 d-flex align-items-center justify-content-between flex-wrap">
                    <ecp-modal
                        v-if="ecpLoginModal"
                        :hash="loginHash"
                        :users-list="usersList"
                        title="Выбор подписи для авторизации"
                        attached
                        @sign="loginBySign"
                        @hidden="ecpLoginModal = false; usersList = []"
                    >
                        <template v-slot:modal-footer="{ onSign, loginEnabled, close }">
                            <b-button variant="danger" @click="close">Отмена</b-button>
                            <b-button
                                :disabled="ecpLoginLoading || !loginEnabled"
                                variant="success"
                                @click="onSign"
                            >Войти по выбранной подписи</b-button>
                        </template>
                    </ecp-modal>
                    <b-button-group>
                        <b-button
                            @click="onPasswordLogin"
                            :disabled="!valid"
                            variant="primary"
                            type="submit"
                        >Войти</b-button>
                        <b-button @click="onEcpLogin">
                            <b-spinner class="mr-1" v-if="tokenLoading" small type="border" />Войти используя ЭЦП
                        </b-button>
                    </b-button-group>
                    <b-button
                        @click="$refs.modal.hide()"
                        :to="{ name: 'auth' }"
                        variant="success"
                        class="d-md-block ml-3 d-sm-none"
                    >Регистрация</b-button>
                </div>
                <small>
                    <b-button variant="link" @click="resetPassword()">Восстановление доступа</b-button>
                </small>
            </template>
        </b-modal>
    </validation-observer>
</template>

<script>
import LoginForm from "./LoginForm.vue";
import EcpModal from "../Ecp/EcpModal";
import authMixin from "./authMixin";

export default {
    name: "AuthLoginModal",
    components: { EcpModal, LoginForm },
    mixins: [authMixin],
    props: {
        id: String,
    },
    methods: {
        resetPassword() {
            this.$refs.modal.hide()
            this.$router.push({name: 'reset-password'})
        }
    }
};
</script>
